import { Component, OnInit, EventEmitter, Output, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray } from '@angular/forms';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { SettingService } from '../services/settingService/setting.service';
import { CommonService } from 'src/app/middleware/common/common.service';
import * as jwt_decode from 'jwt-decode';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { AddFieldsVM } from 'src/app/viewModels/core/add-fields-vm';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { Subscription } from 'rxjs';
import { CCCName } from '../services/settingService/setting.enum';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-create-field',
  templateUrl: './create-field.component.html',
  styleUrls: ['./create-field.component.scss'],
})
export class CreateFieldComponent implements OnInit {
  folderList: any;
  folderName: any;
  givePermission:boolean = false;
  selectedGlobalPermission = '0';
  roleList: any=[];
  roleListFiltered:any=[];
  roleCtrlFormControl = new FormControl();
  FieldNameListFiltered:any=[];
  pageModelData = {
    pageIndex: 0,
    pageSize: 10,
    SearchKey:"",
    databaseID: 0,
    organizationID: 0,
    officeID:0,
    OfficeIDList:[]
  };
  selectedRoleList: any=[];
  selectedFeildList: any=[];
  OfficeIDList: any = [];
  myOfficeID: any;
  responseHolder:any;
  
  updateCustomfieldForm: FormGroup;
  isRequired: boolean;  
  fieldEditData: any;
  fieldFolderType: any;   
  closeEditPopup: boolean = false;  

  updateModel = {
    userID: '',
    databaseID: 0,
    fieldName: '',
    fieldTypeID: 0,
    fieldTypeName: '',
    folderID: 0,
    folderName: '',
    position: 0,
    defaultValue: '',
    isRequired: false,
    isDeactivated: false,
    fieldFolderType: 0,
    placeholder: '',
    fieldID: 0,
    officeID:0,
    OfficeIDList:[]
  };
  updateFieldmodel = {
    userID: '',
    databaseID: 0,
    fieldName: '',
    fieldTypeID: 0,
    position: 0,
    defaultValue: '',
    fieldCategotyTypeID: '',
    organizationID: 0,
    AvailableOn:1,
    fieldNames: null,
    availableonForms:0
  };

  updateCustomField = {    
    rolePermissions:[],
    fieldID: 0,
    userID: '',   
    fieldCategotyTypeID: 0,
    organizationID: 0,
    officeID:0,
    defaultValue:'',
    OfficeIDList:[],     
    selectedFolders: [
      {
        folderID: 0,
        subFolderID: 0,
      },
    ],
  };

  updateFieldResponseHolder: any;       
  isActive: boolean = false; 
  fieldDetailsList: any;
  glbalDisable: boolean = false;
  customDisable: boolean = false;
  corevaluesDropdown: any[] = [];   
  companyvaluesDropdown: any[] = [];
  contactvaluesDropdown: any[] = [];
  timeout = null;
  checkArray:FormArray;
  addCreatefieldForm: FormGroup;
  
  constructor(private formBuilder: FormBuilder,private constant: Constants,private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses,private statusConst: StatusConstant,private loaderService: LoaderService,
    private toastr: ToastrService,private router: Router,private settingsService: SettingService,  
    private commonService: CommonService, private addFieldsVM: AddFieldsVM,private _dataSharingService: DataSharingService) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(
    this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token); 
    var offices=JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
    this.OfficeIDList.push(oe.officeID)	
    if(oe.isMyoffice==true)
      this.myOfficeID=oe.officeID;
    });
    this.folderDetail = this.commonService.getEditData();
    if (this.folderDetail != undefined) {
      this.folderId = this.folderDetail.folderID;
    }
    this.fieldType = this.commonService.getFieldType();
    this.fieldData = this.commonService.getFieldData();
    if (this.fieldData != undefined) {
    }    
  }  



  getAllfolderList = {
    folderID: 0,
    userID: '',
    databaseID: 0,
    organizationID: 0,
    officeID:0,
    OfficeIDList:[]
  };

  folderIdCheckbox: any[] = [];
  getAllSubfolderListResponseHolder: any;

  selectedFolders = {
    folderID: 0,
    subFolderID: 0,
    position: 0,
    viewOrder: 0,
  };

  showFieldVategoryTypeGlobal: boolean = true;
  showFieldVategoryTypecustom: boolean = false;
  coreList: any;
  taskList: any;
  companyList: any;
  contactList: any;
  fileManagerList: any;
  coreValue: any[] = [];
  taskValue: any[] = [];
  fileManagerValue: any[] = [];
  companyValue: any[] = [];
  contactValue: any[] = [];
  dropdownValue: any[] = [];

  addCreadField = {
    permission:0,
    rolePermissions:[],
    userID: '',
    databaseID: 0,
    fieldName: '',
    fieldTypeID: 0,
    position: 0,
    defaultValue: '',
    placeholder: '',
    fieldCategotyTypeID: 0,
    organizationID: 0,
    officeID:0,
    OfficeIDList:[],
    AvailableOn:1,
    selectedFolders: [
      {
        folderID: 0,
        subFolderID: 0,
        position: 0,
        viewOrder: 0,
      },
    ],
    fieldNames: null,
  };

  folderIdCheck: boolean = false;
  dropDownPlace: string = '';
  fieldType: any;
  fieldData: any;
  EditField: boolean = false;
  addFieldResponseHolder: any;
  folderDetail: any;
  folderId: any;
  closeSlideValue: boolean = false;
  currentUser: any;
  getFieldTypeListResponseHolder: any;
  getFieldsListResponseHolder: any;
  fieldTypeList: any[] = [];
  fieldTypeReqModel = {
    userID: '',
    databaseID: 0,
    pageIndex: 1,
    pageSize: 10,
    officeID:0,
    OfficeIDList:[]
  };
  getFieldModel = {
    userID: '',
    databaseID: 0,
    organizationID: 0,
    officeID: 0,
    OfficeIDList:[]
  };
  fieldsList: any[] = [];
  fieldListFolderWise: any[] = [];
  checkBoxFieldArray: Array<any> = [];
  checkBoxFieldAttribute: any = {
    Select: '',
  };

  inputTypeFieldArray: Array<any> = [];
  inputTypeFieldAttribute: any = {
    fieldText: '',
    placeholder: '',
  };

  imageTypeFieldArray: Array<any> = [];
  imageTypeFieldAttribute: any = {
    altText: '',
  };

  dropdownFieldArray: Array<any> = [];
  dropdownFieldAttribute: any = {
    dropdownText: '',
  };

  urlTypeFieldArray: Array<any> = [];
  urlTypeFieldAttribute: any = {
    url: '',
  };

  numberTypeFieldArray: Array<any> = [];
  numberTypeFieldAttribute: any = {
    number: '',
  };

  dateTypeFieldArray: Array<any> = [];
  dateTypeFieldAttribute: any = {
    dateKey: '',
  };

  radioFieldArray: Array<any> = [];
  radioFieldAttribute: any = {
    radioText: '',
  };

  showRadioField: boolean = false;
  showDateField: boolean = false;
  showCurrencyField: boolean = false;
  showNumberField: boolean = false;
  showTextBoxField: boolean = false;
  showImageField: boolean = false;
  showDropdownBoxField: boolean = false;
  showCheckboxField: boolean = false;
  showUrlField: boolean = false;
  selectedItems: any;
  typeSelected: any;
  dropdownFieldOptionArray: any[] = [];
  dropdownFieldOptionAttribute = {
    dropdownId: 0,
    dropdownOptionName: '',
  };
  fieldLabel: any;
  position: any;
  clickEventsubscriptionAddFeildName: Subscription;

  @Output() closeSlide = new EventEmitter<boolean>();
  IconShow:boolean=true;
  selectedCode:string;

  TextName:string="";
  TextIcon:string="";
  spinner:boolean=false;

  CreateFeild:boolean=true;
  ImportFeild:boolean=false;

  CompanyName:string="";
  CoreName:string="";
  ContactName:string="";
  TaskName:string="";
  FileManagerName:string="";

  Feilds: string[] = [];
  allTags: string[] = [];
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  @ViewChild('feildInput') feildInput: ElementRef<HTMLInputElement>;  
  @ViewChild('auto') matAutocomplete: MatAutocomplete;

  ngOnInit(): void {
    this.CreateFeild=true;
    this.ImportFeild=false;
    this.selectedGlobalPermission="0";
    this.addCreatefieldForm = this.formBuilder.group({
      fieldCategoty: ['2', Validators.required],
      fieldTypeID: ['', Validators.required],
      fieldName: ['', Validators.required],
      checkArray: this.formBuilder.array([], []),
      urlPlaceholder: [''],
      textboxPlaceholder: [''],
      numberPlaceholder: [''],
      currencyPlaceholder: [''],
      datePlaceholder: [''],
      dropPlaceholder: [''],
      availableonForms: ['', Validators.required],
    });

    this.updateCustomfieldForm = this.formBuilder.group({
      fieldCategoty: ['', Validators.required],
      fieldTypeID: ['', Validators.required],
      fieldName: ['', Validators.required],
      checkArray: this.formBuilder.array([], []),
      urlPlaceholder: [''],
      textboxPlaceholder: [''],
      numberPlaceholder: [''],
      currencyPlaceholder: [''],
      datePlaceholder: [''],
      dropPlaceholder: [''],
      availableonForms: ['', Validators.required]
    });  

    this.clickEventsubscriptionAddFeildName = this._dataSharingService.getSelectedFolderIdInSetting().subscribe((result) => {
     if (result != '' && result != undefined) {  
         this.addCreatefieldForm = this.formBuilder.group({
          fieldCategoty: ['2', Validators.required],
          fieldTypeID: ['', Validators.required],
          fieldName: ['', Validators.required],
          checkArray: this.formBuilder.array([], []),
          urlPlaceholder: [''],
          textboxPlaceholder: [''],
          numberPlaceholder: [''],
          currencyPlaceholder: [''],
          datePlaceholder: [''],
          dropPlaceholder: [''],
          availableonForms: ['', Validators.required],
         });
  
         this.updateCustomfieldForm = this.formBuilder.group({
           fieldCategoty: ['', Validators.required],
           fieldTypeID: ['', Validators.required],
           fieldName: ['', Validators.required],
           checkArray: this.formBuilder.array([], []),
           urlPlaceholder: [''],
           textboxPlaceholder: [''],
           numberPlaceholder: [''],
           currencyPlaceholder: [''],
           datePlaceholder: [''],
           dropPlaceholder: [''],
           availableonForms: ['', Validators.required]
         });
         this.getFieldTypeDropdown();
         this.getAllFields();
         this.getAllFolder();
         this.getRoleList();
          this.feildInput.nativeElement.value = '';
          this.selectedRoleList=[];
          this.Feilds=[];    
          this.folderIdCheckbox = [];
          this.folderIdCheckbox.push(result);          
          this.givePermission=false;

          this.folderId = result;

          var checkArray :FormArray;
          checkArray = this.addCreatefieldForm.get('checkArray') as FormArray; 
          checkArray.clear();
          checkArray.push(new FormControl(this.folderId));

          checkArray = this.updateCustomfieldForm.get('checkArray') as FormArray;  
          checkArray.clear();
          checkArray.push(new FormControl(this.folderId)); 
          this.folderIdCheck = true;
          this.spinner=false;
        }
      });    
  }

  addpermission(){
    this.givePermission = !this.givePermission
  }

  closecreateField(message: boolean) {
    this.updateCustomfieldForm.reset();
    this.CreateFeild=true;
    this.ImportFeild=false;
    this.FieldNameListFiltered=[];
    this.corevaluesDropdown=[];
    this.contactvaluesDropdown=[];
    this.companyvaluesDropdown=[];
    this.selectedRoleList=[];

    this.selectedGlobalPermission="0";

    this.addCreatefieldForm.reset();
    this.addCreatefieldForm.controls['fieldCategoty'].setValue('2');
    this.showFieldVategoryTypeGlobal = true;
    this.showFieldVategoryTypecustom = false;
    this.clear();
    this.folderIdCheck = true;
    this.selectedRoleList=[];
    //this.addpermission();
    this.closeSlide.emit(message);
  }

  onCheckboxChange(e) {
    const checkArray: FormArray = this.addCreatefieldForm.get('checkArray') as FormArray;
    if (e.checked) {
      let a = e.source.value;
      checkArray.push(new FormControl(e.source.value));
    } else {
      let i: number = 0;
      checkArray.controls.forEach((item: FormControl) => {
        if (item.value == e.source.value) {
          checkArray.removeAt(i);
          return;
        }
        i++;
      });
    }
    if (checkArray.length != 0) {
      this.folderIdCheck = true;
    } else {
      this.folderIdCheck = false;
    }
  }

  onCheckboxChangeImport(e) {
    const checkArray: FormArray = this.updateCustomfieldForm.get('checkArray') as FormArray;
    if (e.checked) {
      let a = e.source.value;
      checkArray.push(new FormControl(e.source.value));
    } else {
      let i: number = 0;
      checkArray.controls.forEach((item: FormControl) => {
        if (item.value == e.source.value) {
          checkArray.removeAt(i);
          return;
        }
        i++;
      });
    }
   
    if (checkArray.length != 0) {
      this.folderIdCheck = true;
    } else {
      this.folderIdCheck = false;
    }
  }

  onRadiobuttonChange(e) {
    if (e.source.value == '2') {
      this.showFieldVategoryTypeGlobal = true;
      this.showFieldVategoryTypecustom = false;
      this.folderIdCheck = false;
    } else {
      this.showFieldVategoryTypecustom = true;
      this.showFieldVategoryTypeGlobal = false;
      this.folderIdCheck = false;
    }
    this.addCreatefieldForm.controls['fieldTypeID'].setValue('');
    this.clear();
  }

  searchRole(val:any){
    if(val!==undefined && val!=="") {
      this.roleListFiltered=this.roleList.filter(m=>m.roleName.toLowerCase().includes(val.toLowerCase()));
      this.roleListFiltered=this.roleListFiltered.filter(m=> !this.selectedRoleList.map(a => a.roleID).includes(m.roleID));
    }
    else{
      this.roleListFiltered=[];
    }
  }
  
  deletePermission(sr:any) {
    this.selectedRoleList= this.selectedRoleList.filter(m=>m.roleID!==sr.roleID);   
  }

  roleSelected(obj:any) {
    this.roleListFiltered=[];
    this.roleCtrlFormControl.setValue("");
    if(this.selectedRoleList.map(a => a.roleID).includes(obj.roleID)) {
    return;
   }
   this.selectedRoleList.push({name:obj.roleName,roleID:obj.roleID,permission:0});
  }


  globalPermission(event){
   this.selectedGlobalPermission=event.value;
  }

  changePermission(sr:any, permission:any){
    this.selectedRoleList.find(m=>m.roleID==sr.roleID).permission=permission;
  }

  async getRoleList() {
    this.loaderService.show();    
    this.pageModelData.pageIndex = 0;
    this.pageModelData.pageSize = 0;
    this.pageModelData.databaseID =  Number( sessionStorage.getItem('databaseId'));
    this.pageModelData.organizationID = Number(sessionStorage.getItem('organizationID'));
    this.pageModelData.officeID = this.myOfficeID;
    this.pageModelData.OfficeIDList = this.OfficeIDList;
    const result = await this.settingsService.getRoleList(this.pageModelData).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
      this.loaderService.hide();
      this.roleList = result.data.roleModel;
    }else{
      this.loaderService.hide();
    }
  }


  addFieldValue(formValues) {
    this.spinner=true;
    this.addCreatefieldForm.markAsPristine();
    if (formValues != undefined) {
      this.loaderService.show();
      this.addCreadField.userID = this.currentUser.UID;
      this.addCreadField.databaseID = parseInt(sessionStorage.getItem('databaseId'));
      this.addCreadField.fieldName = formValues.fieldName;
      this.addCreadField.fieldTypeID = formValues.fieldTypeID;
      this.addCreadField.position = 1;
      this.addCreadField.defaultValue = '';
      this.addCreadField.fieldCategotyTypeID = Number(formValues.fieldCategoty);
      this.addCreadField.organizationID = Number(sessionStorage.getItem('organizationID'));
      this.addCreadField.officeID = this.myOfficeID;
      this.addCreadField.OfficeIDList = this.OfficeIDList;
      this.addCreadField.permission=Number(this.selectedGlobalPermission);
      this.selectedRoleList.forEach(e => {
        this.addCreadField.rolePermissions.push({
          "roleID": e.roleID,
          "permission": e.permission
        })
      });

      this.addCreadField.AvailableOn =Number(formValues.availableonForms);     
      let tempArray = [];
      let post = 1;
      if (this.addCreadField.fieldCategotyTypeID == 3) {
        this.getAllSubfolderListResponseHolder.data.forEach((element) => {
          if (element.folderName == CCCName.Company && this.companyValue != null) {
            if (this.companyValue.length > 0) {
              let count = 0;
              let postcount = 1;
              for (let i of this.companyValue) {
                let copyModel = Object.assign({}, this.selectedFolders);
                copyModel.folderID = element.folderID;
                copyModel.subFolderID = i;
                this.fieldsList.forEach((element1) => {
                  if (element1.folderID == copyModel.folderID) {
                    if (postcount == 1) {
                      count = 1;//element1.fieldData.length + 1; not in use
                      postcount = postcount + 1;
                    }
                    copyModel.position = count;
                    copyModel.viewOrder = count;
                    if (post == 1) {
                      this.addCreadField.position = copyModel.position;
                    }
                    post = post + 1;
                  }
                });
                count = count + 1;
                tempArray.push(copyModel);
              }
            }
          } else if (
            element.folderName == CCCName.Contact && this.contactValue != null) {
            if (this.contactValue.length > 0) {
              let count = 0;
              let postcount = 1;
              for (let i of this.contactValue) {
                let copyModel = Object.assign({}, this.selectedFolders);
                copyModel.folderID = element.folderID;
                copyModel.subFolderID = i;
                this.fieldsList.forEach((element1) => {
                  if (element1.folderID == copyModel.folderID) {
                    if (postcount == 1) {
                      count = 1;//element1.fieldData.length + 1; not in use
                      postcount = postcount + 1;
                    }
                    copyModel.position = count;
                    copyModel.viewOrder = count;
                    if (post == 1) {
                      this.addCreadField.position = copyModel.position;
                    }
                    post = post + 1;
                  }
                });
                count = count + 1;
                tempArray.push(copyModel);
              }
            }
          } else if (element.folderName == CCCName.Core && this.coreValue != null) {
            if (this.coreValue.length > 0) {
              let count = 0;
              let postcount = 1;
              for (let i of this.coreValue) {
                let copyModel = Object.assign({}, this.selectedFolders);
                copyModel.folderID = element.folderID;
                copyModel.subFolderID = i;
                this.fieldsList.forEach((element1) => {
                  if (element1.folderID == copyModel.folderID) {
                    if (postcount == 1) {
                      count = 1;//element1.fieldData.length + 1; not in use
                      postcount = postcount + 1;
                    }
                    copyModel.position = count;
                    copyModel.viewOrder = count;
                    if (post == 1) {
                      this.addCreadField.position = copyModel.position;
                    }
                    post = post + 1;
                  }
                });
                count = count + 1;
                tempArray.push(copyModel);
              }
            }
          } else if (element.folderName == CCCName.Task && this.taskValue != null) {
            if (this.taskValue.length > 0) {
              let count = 0;
              let postcount = 1;
              for (let i of this.taskValue) {
                let copyModel = Object.assign({}, this.selectedFolders);
                copyModel.folderID = element.folderID;
                copyModel.subFolderID = i;
                this.fieldsList.forEach((element1) => {
                  if (element1.folderID == copyModel.folderID) {
                    if (postcount == 1) {
                      count = 1;//element1.fieldData.length + 1; not in use
                      postcount = postcount + 1;
                    }
                    copyModel.position = count;
                    copyModel.viewOrder = count;
                    if (post == 1) {
                      this.addCreadField.position = copyModel.position;
                    }
                    post = post + 1;
                  }
                });
                count = count + 1;
                tempArray.push(copyModel);
              }
            }
          }else if (element.folderName == CCCName.FileManager && this.fileManagerValue != null) {
            if (this.fileManagerValue.length > 0) {
              let count = 0;
              let postcount = 1;
              for (let i of this.fileManagerValue) {
                let copyModel = Object.assign({}, this.selectedFolders);
                copyModel.folderID = element.folderID;
                copyModel.subFolderID = i;
                this.fieldsList.forEach((element1) => {
                  if (element1.folderID == copyModel.folderID) {
                    if (postcount == 1) {
                      count = 1;//element1.fieldData.length + 1; not in use
                      postcount = postcount + 1;
                    }
                    copyModel.position = count;
                    copyModel.viewOrder = count;
                    if (post == 1) {
                      this.addCreadField.position = copyModel.position;
                    }
                    post = post + 1;
                  }
                });
                count = count + 1;
                tempArray.push(copyModel);
              }
            }
          }
        });

        this.addCreadField.selectedFolders = tempArray;
      } else {
        formValues.checkArray.forEach((element) => {
          let copyModel = Object.assign({}, this.selectedFolders);
          copyModel.folderID = element;

          this.fieldsList.forEach((element1) => {
            if (element1.folderID == copyModel.folderID) {
              let   count = 1;//element1.fieldData.length + 1; not in use
              copyModel.position = count;
              copyModel.viewOrder = count;
              if (post == 1) {
                this.addCreadField.position = copyModel.position;
              }
              post = post + 1;
            }
          });
          tempArray.push(copyModel);
        });

        if (tempArray.length == 0 || tempArray == undefined) {
          let copyModel = Object.assign({}, this.selectedFolders);
          copyModel.folderID = this.folderId; //17;

          this.fieldsList.forEach((element1) => {
            if (element1.folderID == copyModel.folderID) {
              let   count = 1;//element1.fieldData.length + 1; not in use
              copyModel.position = count;
              copyModel.viewOrder = count;
              if (post == 1) {
                this.addCreadField.position = copyModel.position;
              }
              post = post + 1;
            }
          });
          tempArray.push(copyModel);
        }
        this.addCreadField.selectedFolders = tempArray;
      }

      if (this.showDropdownBoxField == true) {
        if( this.dropdownFieldArray.length>0){
          this.dropdownFieldArray = this.dropdownFieldArray.filter(el => Object.keys(el).length);
          this.dropdownFieldArray.forEach((element) => {
          //this.addCreadField.defaultValue += element.dropdownText + ',';
          this.addCreadField.defaultValue +=  (element.dropdownText.toString().replace(/,/g, "")) + ',';
          this.addCreadField.placeholder = this.dropDownPlace;
         });
         this.addCreadField.defaultValue =  this.addCreadField.defaultValue.replace(/,\s*$/, "");
        }  
      } else if (this.showCheckboxField == true) {
        if(this.checkBoxFieldArray.length>0){
          this.checkBoxFieldArray = this.checkBoxFieldArray.filter(el => Object.keys(el).length);
          if(this.checkBoxFieldArray.length==0){
            this.addCreadField.defaultValue= " ,";
            this.addCreadField.placeholder= '';
          }else{
            this.checkBoxFieldArray.forEach((element) => {
              this.addCreadField.defaultValue += element.Select + ',';
              this.addCreadField.placeholder = '';
             });
          }  
        }
      } else if (this.showTextBoxField == true) {
          this.inputTypeFieldArray.forEach((element) => {
          this.addCreadField.defaultValue += element.fieldText;
          this.addCreadField.placeholder = element.placeholder;
        });
      } else if (this.showImageField == true) {
          this.imageTypeFieldArray.forEach((element) => {
          this.addCreadField.defaultValue += element.altText;
        });
      } else if (this.showUrlField == true) {
          this.urlTypeFieldArray.forEach((element) => {
          this.addCreadField.placeholder += element.url;
          this.addCreadField.defaultValue = '';
        });
      } else if(this.showNumberField == true || this.showCurrencyField == true) {
          this.numberTypeFieldArray.forEach((element) => {
          this.addCreadField.placeholder += element.number;
          this.addCreadField.defaultValue = '';
        });
      } else if (this.showRadioField == true) {
          this.radioFieldArray.forEach((element) => {
          this.addCreadField.defaultValue += element.radioText + ',';
          this.addCreadField.placeholder = '';
        });
      } else if (this.showDateField == true) {
          this.dateTypeFieldArray.forEach((element) => {
          this.addCreadField.placeholder += element.dateKey;
          this.addCreadField.defaultValue = '';
        });
      }
      //return;
      this.settingsService.addField(this.addCreadField).subscribe((response) => {
          if (response) {
            this.spinner=false;
            this.addFieldResponseHolder = response;
            this.loaderService.hide();
            if(this.addFieldResponseHolder.status == this.statusConst.statusSuccess) {
              this.selectedRoleList=[];
              this.addpermission();
              this.toastr.success('Field created successfully.', '', {
                timeOut: 3000,
              });
            } else {
              this.spinner=false;
               this.toastr.error('This field is already exist in other modules you can edit from there and associate in this module.', '', {
                timeOut: 4000,
              });

              // this.toastr.error(this.addFieldResponseHolder.message, '', {
              //   timeOut: 3000,
              // });
            }
            this.addCreatefieldForm.reset();
            this.clear();
            this.showFieldVategoryTypeGlobal = true;
            this.showFieldVategoryTypecustom = false;
            this.addCreatefieldForm.controls['fieldCategoty'].setValue('2');
            let closePanel = false;
            this.closecreateField(closePanel);
            this._dataSharingService.sendClickEventforfields();
          }
        });
    }
  }

  getFieldTypeDropdown() {
    this.fieldTypeReqModel.userID = this.currentUser.UID;
    this.fieldTypeReqModel.databaseID = parseInt(sessionStorage.getItem('databaseId'));
    this.fieldTypeReqModel.pageSize = 20;
	  this.fieldTypeReqModel.officeID = this.myOfficeID;
    this.fieldTypeReqModel.OfficeIDList = this.OfficeIDList;
    this.settingsService.getFieldTypeList(this.fieldTypeReqModel).subscribe((response) => {
        if (response != undefined) {
          this.getFieldTypeListResponseHolder = response;
          if(this.getFieldTypeListResponseHolder.status == this.statusConst.statusSuccess) {
            this.fieldTypeList = this.getFieldTypeListResponseHolder.data;
            this.fieldTypeList = this.fieldTypeList.filter((e) => e.fieldTypeName != 'Image');
          } else {          
          }
        }
      });
  }

  getAllFolder() {
    this.getAllfolderList.userID = this.currentUser.UID;
    this.getAllfolderList.databaseID = parseInt(sessionStorage.getItem('databaseId'));
    this.getAllfolderList.folderID = 0;
    this.getAllfolderList.officeID = this.myOfficeID;
    this.getAllfolderList.OfficeIDList = this.OfficeIDList;
    this.getAllfolderList.organizationID = Number(sessionStorage.getItem('organizationID'));
    this.settingsService.getAllFolderlist(this.getAllfolderList).subscribe((response) => {
        if (response != undefined) {
          this.getAllSubfolderListResponseHolder = response;
          if(this.getAllSubfolderListResponseHolder.status == this.statusConst.statusSuccess) {
            this.getAllSubfolderListResponseHolder.data.forEach((element) => {
              if (element.folderName == 'Company') {
                this.companyList = element.subFolders;
              } else if (element.folderName == 'Contact') {
                this.contactList = element.subFolders;
              } else if (element.folderName == 'Core') {
                this.coreList = element.subFolders;
              } else if (element.folderName == 'Task') {
                this.taskList = element.subFolders;
              } else if (element.folderName == 'File Manager') {
                this.fileManagerList = element.subFolders;
              }
            });
          } else {           
          }
        }
      });
  }

  displayavailableonTypeSelection(e) {
    if(this.taskValue.length > 0 || this.coreValue.length > 0 || 
       this.contactValue.length > 0 || this.companyValue.length > 0) {
       this.folderIdCheck = true;
      }
    // this.coreValue = e.value;
    // if (
    //   this.taskValue.length == 0 &&
    //   this.coreValue.length == 0 &&
    //   this.contactValue.length == 0 &&
    //   this.companyValue.length == 0
    // ) {
    //   this.folderIdCheck = false;
    // } else {
    //   this.folderIdCheck = true;
    // }
  }

  displayCoreTypeSelection(e) {
    this.coreValue = e.value;
    if (
      this.taskValue.length == 0 &&
      this.coreValue.length == 0 &&
      this.contactValue.length == 0 &&
      this.companyValue.length == 0 &&
      this.fileManagerValue.length == 0
    ) {
      this.folderIdCheck = false;
    } else {
      this.folderIdCheck = true;
    }
  }

  displayTaskTypeSelection(e) {
    this.taskValue = e.value;
    if (
      this.taskValue.length == 0 &&
      this.coreValue.length == 0 &&
      this.contactValue.length == 0 &&
      this.companyValue.length == 0 &&
      this.fileManagerValue.length == 0
    ) {
      this.folderIdCheck = false;
    } else {
      this.folderIdCheck = true;
    }
  }

  displayFileManagerTypeSelection(e) {
    this.fileManagerValue = e.value;
    if (
      this.taskValue.length == 0 &&
      this.coreValue.length == 0 &&
      this.contactValue.length == 0 &&
      this.companyValue.length == 0 &&
      this.fileManagerValue.length == 0
    ) {
      this.folderIdCheck = false;
    } else {
      this.folderIdCheck = true;
    }
  }

  displayCompanyTypeSelection(e) {
    this.companyValue = e.value;
    if (
      this.taskValue.length == 0 &&
      this.coreValue.length == 0 &&
      this.contactValue.length == 0 &&
      this.companyValue.length == 0 &&
      this.fileManagerValue.length == 0
    ) {
      this.folderIdCheck = false;
    } else {
      this.folderIdCheck = true;
    }
  }

  displayContactTypeSelection(e) {
    this.contactValue = e.value;
    if (
      this.taskValue.length == 0 &&
      this.coreValue.length == 0 &&
      this.contactValue.length == 0 &&
      this.companyValue.length == 0 &&
      this.fileManagerValue.length == 0
    ) {
      this.folderIdCheck = false;
    } else {
      this.folderIdCheck = true;
    }
  }

  clear() {
    const checkArray: FormArray = this.addCreatefieldForm.get('checkArray') as FormArray;
    checkArray.clear();
    this.addCreatefieldForm.get('dropPlaceholder').clearValidators();
    this.addCreatefieldForm.get('urlPlaceholder').clearValidators();
    this.addCreatefieldForm.get('numberPlaceholder').clearValidators();
    this.addCreatefieldForm.get('currencyPlaceholder').clearValidators();
    this.addCreatefieldForm.get('datePlaceholder').clearValidators();
    this.addCreatefieldForm.get('textboxPlaceholder').clearValidators();
    this.addCreatefieldForm.get('urlPlaceholder').updateValueAndValidity();
    this.addCreatefieldForm.get('numberPlaceholder').updateValueAndValidity();
    this.addCreatefieldForm.get('currencyPlaceholder').updateValueAndValidity();
    this.addCreatefieldForm.get('datePlaceholder').updateValueAndValidity();
    this.addCreatefieldForm.get('textboxPlaceholder').updateValueAndValidity();
    this.addCreatefieldForm.get('dropPlaceholder').updateValueAndValidity();
    this.showCheckboxField = false;
    this.showDropdownBoxField = false;
    this.showTextBoxField = false;
    this.showImageField = false;
    this.showUrlField = false;
    this.showNumberField = false;
    this.showCurrencyField = false;
    this.showRadioField = false;
    this.showDateField = false;
    this.inputTypeFieldArray = [];
    this.checkBoxFieldArray = [];
    this.dropdownFieldArray = [];
    this.imageTypeFieldArray = [];
    this.urlTypeFieldArray = [];
    this.numberTypeFieldArray = [];
    this.dateTypeFieldArray = [];
    this.radioFieldArray = []; 
    this.taskValue = [];
    this.coreValue = [];
    this.contactValue = [];
    this.companyValue = [];   
  }

  
  getAllFields() { 
    this.getFieldModel.userID = this.currentUser.UID;
    this.getFieldModel.databaseID = parseInt(sessionStorage.getItem('databaseId'));
    this.getFieldModel.organizationID = parseInt(sessionStorage.getItem('organizationID'));
    this.getFieldModel.officeID = this.myOfficeID;
    this.getFieldModel.OfficeIDList = this.OfficeIDList;
    this.settingsService.getAllFolderlist(this.getFieldModel).subscribe((response) => {
    if (response != undefined) {
          this.getFieldsListResponseHolder = response;
          if(this.getFieldsListResponseHolder.status == this.statusConst.statusSuccess) {     
            //m.folderName != "Task" &&     
            this.fieldsList = this.getFieldsListResponseHolder.data.filter((m) =>  m.folderName != "Forms");
           
            var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
            var coreName =[];
            coreName = menuModulesList.filter(x => x.mainModuleName == CCCName.Core); 
            if(coreName.length>0){
              this.CoreName= coreName[0].orgModuleName;
              this.fieldsList.find((item) => item.folderName == CCCName.Core).folderName = this.CoreName;
            }           
            var contName =[];
            contName = menuModulesList.filter(x => x.mainModuleName == CCCName.Contact);
            if(contName.length>0){
              this.ContactName = contName[0].orgModuleName;
              this.fieldsList.find((item) => item.folderName == CCCName.Contact).folderName = this.ContactName;
            }

            var compName=[];
            compName  = menuModulesList.filter(x => x.mainModuleName == CCCName.Company);
            if(compName.length>0){
              this.CompanyName = compName[0].orgModuleName;
              this.fieldsList.find((item) => item.folderName == CCCName.Company).folderName = this.CompanyName;
            }     
                 
            let TaskmoduleName=[];
            TaskmoduleName  = menuModulesList.filter(x => x.mainModuleName == CCCName.Task || x.mainModuleName==CCCName.NewTask);
            if(TaskmoduleName.length>0){
              this.TaskName = TaskmoduleName[0].orgModuleName;
              this.fieldsList.find((item) => item.folderName == CCCName.Task).folderName = this.TaskName;
            }

            let FileManagermoduleName=[];
            FileManagermoduleName  = menuModulesList.filter(x => x.mainModuleName == CCCName.FileManager);
            if(FileManagermoduleName.length>0){
              this.FileManagerName = FileManagermoduleName[0].orgModuleName;
              this.fieldsList.find((item) => item.folderName == CCCName.FileManager).folderName = this.FileManagerName;
            }

            this.fieldsList.forEach((element) => {
              if (element.folderID == this.folderId) {
                this.fieldListFolderWise = element.fieldData;
              }
            });
          } else {           
          }
        }
      });
  }

 
  addValueFieldRadio() {
    let tempObject = Object.assign({}, this.radioFieldAttribute);
    this.radioFieldArray.push(tempObject);
  }

  addValueFieldropdown() {  
    this.dropdownFieldAttribute = null;
    let tempObject = Object.assign({}, this.dropdownFieldAttribute);
    this.dropdownFieldArray.push(tempObject);
  }
  

  displayFieldOnFieldTypeSelection(event) {
    this.IconShow=false;
    var getdata = this.fieldTypeList.filter((s) => s.fieldTypeID == event.value);
    if(getdata.length > 0){
      this.TextName= getdata[0].fieldTypeName;
      this.TextIcon= getdata[0].icon;
    }

    if (event != undefined) {
      let fieldTypeName = '';
      this.fieldTypeList.forEach((element) => {
        if (element.fieldTypeID == event.value) {
          if(element.fieldTypeName == this.constant.TextArea || element.fieldTypeName == this.constant.TextBox) {
            this.showTextBoxField = true;
            this.showDropdownBoxField = false;
            this.showCheckboxField = false;
            this.showImageField = false;
            this.showCurrencyField = false;
            this.showNumberField = false;
            this.showUrlField = false;
            this.showRadioField = false;
            this.showDateField = false;
            this.inputTypeFieldArray = [];
            this.inputTypeFieldArray.push(this.inputTypeFieldAttribute);
            this.checkBoxFieldArray = [];
            this.dropdownFieldArray = [];
            this.imageTypeFieldArray = [];
            this.urlTypeFieldArray = [];
            this.numberTypeFieldArray = [];
            this.dateTypeFieldArray = [];
            this.radioFieldArray = [];
            this.addCreatefieldForm.get('textboxPlaceholder').setValidators(Validators.required);
            this.addCreatefieldForm.get('urlPlaceholder').clearValidators();
            this.addCreatefieldForm.get('numberPlaceholder').clearValidators();
            this.addCreatefieldForm.get('currencyPlaceholder').clearValidators();
            this.addCreatefieldForm.get('datePlaceholder').clearValidators();
            this.addCreatefieldForm.get('dropPlaceholder').clearValidators();
            this.addCreatefieldForm.get('urlPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('numberPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('currencyPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('datePlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('dropPlaceholder').updateValueAndValidity();
          } else if (
            element.fieldTypeName == this.constant.DropDownField ||
            element.fieldTypeName == this.constant.MultiSelect
          ) {
            this.showDropdownBoxField = true;
            this.showTextBoxField = false;
            this.showCheckboxField = false;
            this.showImageField = false;
            this.showCurrencyField = false;
            this.showRadioField = false;
            this.showNumberField = false;
            this.showUrlField = false;
            this.dropDownPlace = '';
            this.dropdownFieldArray = [];
            this.dropdownFieldArray.push(this.dropdownFieldAttribute);
            this.inputTypeFieldArray = [];
            this.checkBoxFieldArray = [];
            this.imageTypeFieldArray = [];
            this.urlTypeFieldArray = [];
            this.numberTypeFieldArray = [];
            this.dateTypeFieldArray = [];
            this.radioFieldArray = [];
            this.addCreatefieldForm.get('dropPlaceholder').setValidators(Validators.required);
            this.addCreatefieldForm.get('urlPlaceholder').clearValidators();
            this.addCreatefieldForm.get('numberPlaceholder').clearValidators();
            this.addCreatefieldForm.get('currencyPlaceholder').clearValidators();
            this.addCreatefieldForm.get('datePlaceholder').clearValidators();
            this.addCreatefieldForm.get('textboxPlaceholder').clearValidators();
            this.addCreatefieldForm.get('urlPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('numberPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('currencyPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('datePlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('textboxPlaceholder').updateValueAndValidity();
          } else if (element.fieldTypeName == this.constant.CheckboxField) {
            this.showCheckboxField = true;
            this.showDropdownBoxField = false;
            this.showTextBoxField = false;
            this.showImageField = false;
            this.showRadioField = false;
            this.showUrlField = false;
            this.showDateField = false;
            this.checkBoxFieldArray = [];
            this.checkBoxFieldAttribute = [];
            this.checkBoxFieldArray.push(this.checkBoxFieldAttribute);
            this.inputTypeFieldArray = [];
            this.dropdownFieldArray = [];
            this.imageTypeFieldArray = [];
            this.urlTypeFieldArray = [];
            this.numberTypeFieldArray = [];
            this.dateTypeFieldArray = [];
            this.radioFieldArray = [];
            this.addCreatefieldForm.get('dropPlaceholder').clearValidators();
            this.addCreatefieldForm.get('urlPlaceholder').clearValidators();
            this.addCreatefieldForm.get('numberPlaceholder').clearValidators();
            this.addCreatefieldForm.get('currencyPlaceholder').clearValidators();
            this.addCreatefieldForm.get('datePlaceholder').clearValidators();
            this.addCreatefieldForm.get('textboxPlaceholder').clearValidators();
            this.addCreatefieldForm.get('urlPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('numberPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('currencyPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('datePlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('textboxPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('dropPlaceholder').updateValueAndValidity();
          } else if (element.fieldTypeName == this.constant.Image) {
            this.showCheckboxField = false;
            this.showDropdownBoxField = false;
            this.showTextBoxField = false;
            this.showImageField = true;
            this.showCurrencyField = false;
            this.showNumberField = false;
            this.showRadioField = false;
            this.showUrlField = false;
            this.showDateField = false;
            this.imageTypeFieldArray = [];
            this.imageTypeFieldArray.push(this.imageTypeFieldAttribute);
            this.inputTypeFieldArray = [];
            this.dropdownFieldArray = [];
            this.checkBoxFieldArray = [];
            this.urlTypeFieldArray = [];
            this.numberTypeFieldArray = [];
            this.dateTypeFieldArray = [];
            this.radioFieldArray = [];
            this.addCreatefieldForm.get('dropPlaceholder').clearValidators();
            this.addCreatefieldForm.get('urlPlaceholder').clearValidators();
            this.addCreatefieldForm.get('numberPlaceholder').clearValidators();
            this.addCreatefieldForm.get('currencyPlaceholder').clearValidators();
            this.addCreatefieldForm.get('datePlaceholder').clearValidators();
            this.addCreatefieldForm.get('textboxPlaceholder').clearValidators();
            this.addCreatefieldForm.get('urlPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('numberPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('currencyPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('datePlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('textboxPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('dropPlaceholder').updateValueAndValidity();
          } else if (element.fieldTypeName == this.constant.URL) {
            this.showCheckboxField = false;
            this.showDropdownBoxField = false;
            this.showTextBoxField = false;
            this.showImageField = false;
            this.showUrlField = true;
            this.showCurrencyField = false;
            this.showRadioField = false;
            this.showNumberField = false;
            this.showDateField = false;
            this.urlTypeFieldArray = [];
            this.urlTypeFieldArray.push(this.urlTypeFieldAttribute);
            this.inputTypeFieldArray = [];
            this.dropdownFieldArray = [];
            this.checkBoxFieldArray = [];
            this.imageTypeFieldArray = [];
            this.numberTypeFieldArray = [];
            this.dateTypeFieldArray = [];
            this.radioFieldArray = [];
            this.addCreatefieldForm.get('urlPlaceholder').setValidators(Validators.required);
            this.addCreatefieldForm.get('textboxPlaceholder').clearValidators();
            this.addCreatefieldForm.get('numberPlaceholder').clearValidators();
            this.addCreatefieldForm.get('currencyPlaceholder').clearValidators();
            this.addCreatefieldForm.get('datePlaceholder').clearValidators();
            this.addCreatefieldForm.get('dropPlaceholder').clearValidators();
            this.addCreatefieldForm.get('numberPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('currencyPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('datePlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('textboxPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('dropPlaceholder').updateValueAndValidity();
          } else if (element.fieldTypeName == this.constant.Number || element.fieldTypeName ==this.constant.Address) {
            this.showCheckboxField = false;
            this.showDropdownBoxField = false;
            this.showTextBoxField = false;
            this.showImageField = false;
            this.showUrlField = false;
            this.showNumberField = true;
            this.showCurrencyField = false;
            this.showRadioField = false;
            this.showDateField = false;
            this.numberTypeFieldArray = [];
            this.numberTypeFieldArray.push(this.numberTypeFieldAttribute);
            this.inputTypeFieldArray = [];
            this.dropdownFieldArray = [];
            this.checkBoxFieldArray = [];
            this.imageTypeFieldArray = [];
            this.dateTypeFieldArray = [];
            this.urlTypeFieldArray = [];
            this.radioFieldArray = [];
            this.addCreatefieldForm.get('numberPlaceholder').setValidators(Validators.required);
            this.addCreatefieldForm.get('urlPlaceholder').clearValidators();
            this.addCreatefieldForm.get('textboxPlaceholder').clearValidators();
            this.addCreatefieldForm.get('currencyPlaceholder').clearValidators();
            this.addCreatefieldForm.get('datePlaceholder').clearValidators();
            this.addCreatefieldForm.get('dropPlaceholder').clearValidators();
            this.addCreatefieldForm.get('urlPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('currencyPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('datePlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('textboxPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('dropPlaceholder').updateValueAndValidity();
          } else if (element.fieldTypeName == this.constant.Currency) {
            this.showCheckboxField = false;
            this.showDropdownBoxField = false;
            this.showTextBoxField = false;
            this.showImageField = false;
            this.showUrlField = false;
            this.showNumberField = false;
            this.showCurrencyField = true;
            this.showRadioField = false;
            this.showDateField = false;
            this.numberTypeFieldArray = [];
            this.numberTypeFieldArray.push(this.numberTypeFieldAttribute);
            this.inputTypeFieldArray = [];
            this.dropdownFieldArray = [];
            this.checkBoxFieldArray = [];
            this.imageTypeFieldArray = [];
            this.dateTypeFieldArray = [];
            this.urlTypeFieldArray = [];
            this.radioFieldArray = [];
            this.addCreatefieldForm.get('currencyPlaceholder').setValidators(Validators.required);
            this.addCreatefieldForm.get('urlPlaceholder').clearValidators();
            this.addCreatefieldForm.get('numberPlaceholder').clearValidators();
            this.addCreatefieldForm.get('textboxPlaceholder').clearValidators();
            this.addCreatefieldForm.get('datePlaceholder').clearValidators();
            this.addCreatefieldForm.get('dropPlaceholder').clearValidators();
            this.addCreatefieldForm.get('urlPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('numberPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('datePlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('textboxPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('dropPlaceholder').updateValueAndValidity();
          } else if (element.fieldTypeName == this.constant.Date) {
            this.showCheckboxField = false;
            this.showDropdownBoxField = false;
            this.showTextBoxField = false;
            this.showImageField = false;
            this.showUrlField = false;
            this.showNumberField = false;
            this.showCurrencyField = false;
            this.showRadioField = false;
            this.showDateField = true;
            this.dateTypeFieldArray = [];
            this.dateTypeFieldArray.push(this.dateTypeFieldAttribute);
            this.inputTypeFieldArray = [];
            this.dropdownFieldArray = [];
            this.checkBoxFieldArray = [];
            this.imageTypeFieldArray = [];
            this.numberTypeFieldArray = [];
            this.urlTypeFieldArray = [];
            this.radioFieldArray = [];
            this.addCreatefieldForm.get('datePlaceholder').setValidators(Validators.required);
            this.addCreatefieldForm.get('urlPlaceholder').clearValidators();
            this.addCreatefieldForm.get('numberPlaceholder').clearValidators();
            this.addCreatefieldForm.get('currencyPlaceholder').clearValidators();
            this.addCreatefieldForm.get('textboxPlaceholder').clearValidators();
            this.addCreatefieldForm.get('dropPlaceholder').clearValidators();
            this.addCreatefieldForm.get('urlPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('numberPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('currencyPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('textboxPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('dropPlaceholder').updateValueAndValidity();
          } else {
            this.showCheckboxField = false;
            this.showDropdownBoxField = false;
            this.showTextBoxField = false;
            this.showImageField = false;
            this.showUrlField = false;
            this.showNumberField = false;
            this.showCurrencyField = false;
            this.showDateField = false;
            this.showRadioField = false;
            this.radioFieldArray.push(this.radioFieldAttribute);
            this.inputTypeFieldArray = [];
            this.dropdownFieldArray = [];
            this.checkBoxFieldArray = [];
            this.imageTypeFieldArray = [];
            this.numberTypeFieldArray = [];
            this.urlTypeFieldArray = [];
            this.dateTypeFieldArray = [];
            this.addCreatefieldForm.get('dropPlaceholder').clearValidators();
            this.addCreatefieldForm.get('urlPlaceholder').clearValidators();
            this.addCreatefieldForm.get('numberPlaceholder').clearValidators();
            this.addCreatefieldForm.get('currencyPlaceholder').clearValidators();
            this.addCreatefieldForm.get('datePlaceholder').clearValidators();
            this.addCreatefieldForm.get('textboxPlaceholder').clearValidators();
            this.addCreatefieldForm.get('urlPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('numberPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('currencyPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('datePlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('textboxPlaceholder').updateValueAndValidity();
            this.addCreatefieldForm.get('dropPlaceholder').updateValueAndValidity();
          }
        }
      });
    }
  }

 
  // ========================== Import Feild Name  ==========================================// 

  searchFeildName(val:any){
    this.FieldNameListFiltered=[];
    if(val && val.length>2){
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.getSearchFieldName(val)
      }, 500);
    }else{
      this.FieldNameListFiltered=[];
    }
  }

  getSearchFieldName(searchValue: any) {
    if (searchValue == "" || searchValue == null || searchValue == undefined) {
      this.FieldNameListFiltered = [];
      return;
    }
    var ReqModel = {
      fieldName: searchValue.trim(),
      userID: this.currentUser.UID,
      isSearch:true,
      organizationID:  Number(sessionStorage.getItem('organizationID')),
      officeID:this.myOfficeID     
    }
    this.settingsService.SearchFieldForImport(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.FieldNameListFiltered = this.responseHolder.data;        
          this.loaderService.hide();
        } else {
          this.showFieldVategoryTypeGlobal;
          this.showFieldVategoryTypecustom;

          this.updateCustomfieldForm.reset();
          this.addCreatefieldForm.reset();

          if(this.showFieldVategoryTypecustom==true){
            this.showFieldVategoryTypecustom = true;
            this.showFieldVategoryTypeGlobal = false;
            this.addCreatefieldForm.controls['fieldCategoty'].setValue('3');
          }
          if(this.showFieldVategoryTypeGlobal==true){
            this.showFieldVategoryTypecustom = false;
            this.showFieldVategoryTypeGlobal = true;
           this.addCreatefieldForm.controls['fieldCategoty'].setValue('2');
          }
         
          this.CreateFeild=true;
          this.ImportFeild=false;        
      
          this.selectedGlobalPermission="0";         
          this.addCreatefieldForm.controls['fieldName'].setValue(searchValue);        
         
          this.FieldNameListFiltered=[];
          this.folderIdCheckbox = [];  
          this.folderIdCheckbox.push(this.folderId);   
          var checkArray :FormArray;
          checkArray = this.addCreatefieldForm.get('checkArray') as FormArray; 
          checkArray.clear();
          checkArray.push(new FormControl(this.folderId));

          checkArray = this.updateCustomfieldForm.get('checkArray') as FormArray;  
          checkArray.clear();
          checkArray.push(new FormControl(this.folderId));   
          this.spinner=false;

          this.loaderService.hide();
        }
      } else {
        this.FieldNameListFiltered=[];
        this.loaderService.hide();
      }
    });
  }

  FeildIdForImport:number=0;

  FeildSelected(obj:any) {   
    this.CreateFeild=false;
    this.ImportFeild=true;
    this.FieldNameListFiltered=[];
    this.selectedRoleList=[];
    this.FeildIdForImport= obj.fieldID;

    this.getGlobalFieldDetails(obj);  
  }


  getGlobalFieldDetails(obj) { 
    var ReqModel={
      databaseID: parseInt(sessionStorage.getItem('databaseId')),
      organizationID:parseInt(sessionStorage.getItem('organizationID')),
      userID:this.currentUser.UID,
      folderID:0,
      fieldID:obj.fieldID,
      officeID:this.myOfficeID,
      OfficeIDList:this.OfficeIDList
    }   
    this.loaderService.show();
    this.settingsService.getCustomdetails(ReqModel).subscribe((response) => {
     if (response != undefined) {
          this.loaderService.hide();
          this.getFieldsListResponseHolder = response;
          if(this.getFieldsListResponseHolder.status == this.statusConst.statusSuccess) {
            this.updateFieldmodel.availableonForms= this.getFieldsListResponseHolder.data.availableOnForms;
            this.fieldDetailsList = this.getFieldsListResponseHolder.data;
            this.folderIdCheck = true;
            if(this.getFieldsListResponseHolder.data.persmission)
            this.selectedGlobalPermission= String(this.getFieldsListResponseHolder.data.persmission);
            if(this.getFieldsListResponseHolder.data.rolePermissions){
              this.getFieldsListResponseHolder.data.rolePermissions.forEach(e => {
                this.selectedRoleList.push({isDeleted:false,name:e.roleName,roleID:e.roleID,permission:e.permission,fieldPermissionID:e.fieldPermissionID,action:0});
              });
            }
            this.updateFieldmodel.fieldCategotyTypeID = String(this.fieldDetailsList.fieldCategoryID);
            this.updateFieldmodel.fieldName = this.fieldDetailsList.fieldName;
            this.updateFieldmodel.fieldTypeID = this.fieldDetailsList.fieldTypeID;
            if (this.updateFieldmodel.fieldCategotyTypeID == '2') {
              this.showFieldVategoryTypeGlobal = true;
              this.showFieldVategoryTypecustom = false;
              this.glbalDisable = false;
              this.customDisable = true;
              const checkArray: FormArray = this.updateCustomfieldForm.get('checkArray') as FormArray;
              //&& e.folderName!='Task'
              var availableOn = this.fieldDetailsList.availableOn.filter((e) => e.folderName != 'Forms');

              availableOn.forEach((element) => {
                if (element.isChecked == true) {
                  this.folderIdCheckbox.push(element.folderID);
                  checkArray.push(new FormControl(element.folderID));
                }
              });
            } else {
              this.showFieldVategoryTypecustom = true;
              this.showFieldVategoryTypeGlobal = false;
              this.glbalDisable = true;
              this.customDisable = false;
              this.folderIdCheck = false;
              this.fieldDetailsList.availableOn.forEach((element) => {
                if (element.subFolders.length > 0) {
                  if (element.folderName == CCCName.Company) {
                    element.subFolders.forEach((e) => {
                      if (e.isChecked == true) {
                        this.companyvaluesDropdown.push(e.subFolderID);
                      }
                    });
                  } else if (element.folderName == CCCName.Contact) {
                    element.subFolders.forEach((e) => {
                      if (e.isChecked == true) {
                        this.contactvaluesDropdown.push(e.subFolderID);
                      }
                    });
                  } else if (element.folderName == CCCName.Core) {
                    element.subFolders.forEach((e) => {
                      if (e.isChecked == true) {
                        this.corevaluesDropdown.push(e.subFolderID);
                      }
                    });
                  }
                }
              });
            }
            this.fieldData = this.fieldDetailsList;
           this.bindDataForEdit(this.fieldData);
          } else {
            this.loaderService.hide();           
          }
        }
        this.loaderService.hide();
      });
  }


  bindDataForEdit(editData) {
    if(this.fieldData.fieldTypeName == this.constant.TextArea || this.fieldData.fieldTypeName == this.constant.TextBox ) {
      this.showTextBoxField = true;
      this.showDropdownBoxField = false;
      this.showCheckboxField = false;
      this.showImageField = false;
      this.showUrlField = false;
      this.showNumberField = false;
      this.showCurrencyField = false;
      this.showDateField = false;
      this.showRadioField = false;
      this.inputTypeFieldArray = [];
      this.inputTypeFieldAttribute.fieldText = this.fieldData.defaultValue;
      this.inputTypeFieldAttribute.placeholder = this.fieldData.placeholder;
      this.inputTypeFieldArray.push(this.inputTypeFieldAttribute);
      this.checkBoxFieldArray = [];
      this.dropdownFieldArray = [];
      this.imageTypeFieldArray = [];
      this.urlTypeFieldArray = [];
      this.dateTypeFieldArray = [];
      this.numberTypeFieldArray = [];
      this.radioFieldArray = [];
      this.updateCustomfieldForm.get('textboxPlaceholder').setValidators(Validators.required);
    } else if (
      this.fieldData.fieldTypeName == this.constant.DropDownField ||
      this.fieldData.fieldTypeName == this.constant.MultiSelect) {
      this.showDropdownBoxField = true;
      this.showTextBoxField = false;
      this.showCheckboxField = false;
      this.showImageField = false;
      this.showUrlField = false;
      this.showNumberField = false;
      this.showCurrencyField = false;
      this.showDateField = false;
      this.showRadioField = false;      
      var dropdownValue = this.fieldData.defaultValue.replace(/,\s*$/, '');
      var Valuearray=[];
      Valuearray = dropdownValue.split(',');
      if(Valuearray.length>0){
        Valuearray = Valuearray.filter(el => Object.keys(el).length);
        if(Valuearray.length>0){
          Valuearray.forEach((element) => {
            let copyModel = Object.assign({}, this.dropdownFieldAttribute);
            copyModel.dropdownText = element;
            this.dropdownFieldArray.push(copyModel);
          });
        }       
      }      
      this.dropDownPlace = this.fieldData.placeholder;
      this.urlTypeFieldArray = [];
      this.inputTypeFieldArray = [];
      this.checkBoxFieldArray = [];
      this.imageTypeFieldArray = [];
      this.dateTypeFieldArray = [];
      this.numberTypeFieldArray = [];
      this.radioFieldArray = [];
      this.updateCustomfieldForm.get('dropPlaceholder').setValidators(Validators.required);
    } else if (this.fieldData.fieldTypeName == this.constant.RadioButton) {
      this.showDropdownBoxField = false;
      this.showTextBoxField = false;
      this.showCheckboxField = false;
      this.showImageField = false;
      this.showUrlField = false;
      this.showNumberField = false;
      this.showCurrencyField = false;
      this.showDateField = false;
      this.showRadioField = true;    
      let Valuearray = this.fieldData.defaultValue.split(',');
      Valuearray.forEach((element) => {
        let copyModel = Object.assign({}, this.radioFieldAttribute);
        copyModel.radioText = element;
        this.radioFieldArray.push(copyModel);
      });
      this.urlTypeFieldArray = [];
      this.inputTypeFieldArray = [];
      this.checkBoxFieldArray = [];
      this.imageTypeFieldArray = [];
      this.dateTypeFieldArray = [];
      this.numberTypeFieldArray = [];
    } else if (this.fieldData.fieldTypeName == this.constant.Image) {
      this.showDropdownBoxField = false;
      this.showImageField = true;
      this.showTextBoxField = false;
      this.showCheckboxField = false;
      this.showNumberField = false;
      this.showUrlField = false;
      this.showCurrencyField = false;
      this.showDateField = false;
      this.showRadioField = false;    
      this.imageTypeFieldAttribute.altText = this.fieldData.defaultValue;
      this.imageTypeFieldArray.push(this.imageTypeFieldAttribute);
      this.urlTypeFieldArray = [];
      this.inputTypeFieldArray = [];
      this.checkBoxFieldArray = [];
      this.dropdownFieldArray = [];
      this.dateTypeFieldArray = [];
      this.numberTypeFieldArray = [];
      this.radioFieldArray = [];
    } else if (this.fieldData.fieldTypeName == this.constant.URL) {
      this.showDropdownBoxField = false;
      this.showUrlField = true;
      this.showTextBoxField = false;
      this.showCheckboxField = false;
      this.showImageField = false;
      this.showNumberField = false;
      this.showCurrencyField = false;
      this.showDateField = false;
      this.showRadioField = false;     
      this.urlTypeFieldAttribute.url = this.fieldData.placeholder;
      this.urlTypeFieldArray.push(this.urlTypeFieldAttribute);
      this.imageTypeFieldArray = [];
      this.inputTypeFieldArray = [];
      this.checkBoxFieldArray = [];
      this.dropdownFieldArray = [];
      this.dateTypeFieldArray = [];
      this.numberTypeFieldArray = [];
      this.radioFieldArray = [];
      this.updateCustomfieldForm.get('urlPlaceholder').setValidators(Validators.required);
    } else if (this.fieldData.fieldTypeName == this.constant.Number) {
      this.showDropdownBoxField = false;
      this.showImageField = false;
      this.showUrlField = false;
      this.showNumberField = true;
      this.showTextBoxField = false;
      this.showCheckboxField = false;
      this.showCurrencyField = false;
      this.showDateField = false;
      this.showRadioField = false;   
      this.numberTypeFieldAttribute.number = this.fieldData.placeholder;
      this.numberTypeFieldArray.push(this.numberTypeFieldAttribute);
      this.imageTypeFieldArray = [];
      this.inputTypeFieldArray = [];
      this.checkBoxFieldArray = [];
      this.dropdownFieldArray = [];
      this.urlTypeFieldArray = [];
      this.dateTypeFieldArray = [];
      this.radioFieldArray = [];
      this.updateCustomfieldForm.get('numberPlaceholder').setValidators(Validators.required);
    } else if (this.fieldData.fieldTypeName == this.constant.Currency) {
      this.showDropdownBoxField = false;
      this.showImageField = false;
      this.showUrlField = false;
      this.showNumberField = false;
      this.showTextBoxField = false;
      this.showCheckboxField = false;
      this.showCurrencyField = true;
      this.showDateField = false;
      this.showRadioField = false;    
      this.numberTypeFieldAttribute.number = this.fieldData.placeholder;
      this.numberTypeFieldArray.push(this.numberTypeFieldAttribute);
      this.imageTypeFieldArray = [];
      this.inputTypeFieldArray = [];
      this.checkBoxFieldArray = [];
      this.dropdownFieldArray = [];
      this.urlTypeFieldArray = [];
      this.dateTypeFieldArray = [];
      this.radioFieldArray = [];
      this.updateCustomfieldForm.get('currencyPlaceholder').setValidators(Validators.required);
    } else if (this.fieldData.fieldTypeName == this.constant.Date) {
      this.showDropdownBoxField = false;
      this.showImageField = false;
      this.showUrlField = false;
      this.showNumberField = false;
      this.showTextBoxField = false;
      this.showCheckboxField = false;
      this.showCurrencyField = false;
      this.showDateField = true;
      this.showRadioField = false;     
      this.dateTypeFieldAttribute.dateKey = this.fieldData.placeholder;
      this.dateTypeFieldArray.push(this.dateTypeFieldAttribute);
      this.imageTypeFieldArray = [];
      this.inputTypeFieldArray = [];
      this.checkBoxFieldArray = [];
      this.dropdownFieldArray = [];
      this.urlTypeFieldArray = [];
      this.numberTypeFieldArray = [];
      this.radioFieldArray = [];
      this.updateCustomfieldForm.get('datePlaceholder').setValidators(Validators.required);
    } else if (this.fieldData.fieldTypeName == this.constant.CheckboxField) {
      this.showCheckboxField = true;
      this.showDropdownBoxField = false;
      this.showTextBoxField = false;
      this.showUrlField = false;
      this.showImageField = false;
      this.showNumberField = false;
      this.showCurrencyField = false;
      this.showDateField = false;
      this.showRadioField = false;     
      var checkboxValue = this.fieldData.defaultValue.replace(/,\s*$/, '');
      var Valuearray=[];
      Valuearray = checkboxValue.split(',');
      if(Valuearray.length>0){
        Valuearray = Valuearray.filter(el => Object.keys(el).length);
        if(Valuearray.length>0){
          Valuearray.forEach((element) => {
            let copyModel = Object.assign({}, this.checkBoxFieldAttribute);
            copyModel.Select = element;
            this.checkBoxFieldArray.push(copyModel);
          });
        }       
      }  
      this.inputTypeFieldArray = [];
      this.dropdownFieldArray = [];
      this.imageTypeFieldArray = [];
      this.urlTypeFieldArray = [];
      this.dateTypeFieldArray = [];
      this.numberTypeFieldArray = [];
      this.radioFieldArray = [];
    } else {
    }
  }

  
  // Import Feild

  importField(formValues) {
    this.spinner=true;
    this.folderIdCheck = false;
    this.loaderService.show();   
    this.updateCustomField.defaultValue='';
    this.updateCustomField.userID = this.currentUser.UID;
    this.updateCustomField.organizationID = Number(sessionStorage.getItem('organizationID'));    
    this.updateCustomField.officeID = this.myOfficeID;    
    this.updateCustomField.fieldID = this.FeildIdForImport;//this.fieldData.fieldID;   
    this.updateCustomField.OfficeIDList = this.OfficeIDList;
    this.updateCustomField.fieldCategotyTypeID = parseInt(this.updateFieldmodel.fieldCategotyTypeID);
    this.selectedRoleList.forEach(e => {
        this.updateCustomField.rolePermissions.push({
          "roleID": e.roleID,
          "permission": e.permission,
         // "fieldPermissionID": e.fieldPermissionID,
         // "fieldID": this.fieldData.fieldID,
         // "organizationID":Number(sessionStorage.getItem('organizationID')),
         // "action": e.action 
          //Add=1,
         // Modified=2,
         // Remove=3
        })
      });
   
    let tempArray = [];  
    if (this.updateCustomField.fieldCategotyTypeID == 3) {
      if (this.corevaluesDropdown.length > 0) {
        this.fieldDetailsList.availableOn.forEach((element) => {
          if (element.folderName == CCCName.Core) {
            for (let i of this.corevaluesDropdown) {
              let copyModel = Object.assign({}, this.selectedFolders);
              copyModel.folderID = element.folderID;
              copyModel.subFolderID = i;
              tempArray.push(copyModel);
            }
          }
        });
      }

      if (this.contactvaluesDropdown.length > 0) {
        this.fieldDetailsList.availableOn.forEach((element) => {
          if (element.folderName == CCCName.Contact) {
            for (let i of this.contactvaluesDropdown) {
              let copyModel = Object.assign({}, this.selectedFolders);
              copyModel.folderID = element.folderID;
              copyModel.subFolderID = i;
              tempArray.push(copyModel);
            }
          }
        });
      }   

      if (this.companyvaluesDropdown.length > 0) {
        this.fieldDetailsList.availableOn.forEach((element) => {
          if (element.folderName == CCCName.Company) {
            for (let i of this.companyvaluesDropdown) {
              let copyModel = Object.assign({}, this.selectedFolders);
              copyModel.folderID = element.folderID;
              copyModel.subFolderID = i;
              tempArray.push(copyModel);
            }
          }
        });
      }
      tempArray =tempArray.filter((m) => m.folderID !=null);
      this.updateCustomField.selectedFolders = tempArray;
    } else {   
      formValues.checkArray.forEach((element) => {
        let copyModel = Object.assign({}, this.selectedFolders);
        copyModel.folderID = element;
        tempArray.push(copyModel);
      });
      tempArray =tempArray.filter((m) => m.folderID !=null);
      this.updateCustomField.selectedFolders = tempArray;
    } 
   
    if (this.showDropdownBoxField == true) {
        if( this.dropdownFieldArray.length>0){
          this.dropdownFieldArray = this.dropdownFieldArray.filter(el => Object.keys(el).length);
          this.dropdownFieldArray.forEach((element) => {         
          this.updateCustomField.defaultValue +=  (element.dropdownText.toString().replace(/,/g, "")) + ',';         
         });
         this.updateCustomField.defaultValue =  this.updateCustomField.defaultValue.replace(/,\s*$/, "");
        }  
      } else if (this.showCheckboxField == true) {
        if(this.checkBoxFieldArray.length>0){
          this.checkBoxFieldArray = this.checkBoxFieldArray.filter(el => Object.keys(el).length);
          if(this.checkBoxFieldArray.length==0){
            this.updateCustomField.defaultValue= " ,";          
          }else{
            this.checkBoxFieldArray.forEach((element) => {
              this.updateCustomField.defaultValue += element.Select + ',';              
             });
          }  
        }
      } else if (this.showTextBoxField == true) {
          this.inputTypeFieldArray.forEach((element) => {
          this.updateCustomField.defaultValue += element.fieldText;          
        });
      } else if (this.showImageField == true) {
          this.imageTypeFieldArray.forEach((element) => {
          this.updateCustomField.defaultValue += element.altText;
        });
      } else if (this.showUrlField == true) {
          this.urlTypeFieldArray.forEach((element) => {         
          this.updateCustomField.defaultValue = '';
        });
      } else if(this.showNumberField == true || this.showCurrencyField == true) {
          this.numberTypeFieldArray.forEach((element) => {         
          this.updateCustomField.defaultValue = '';
        });
      } else if (this.showRadioField == true) {
          this.radioFieldArray.forEach((element) => {
          this.updateCustomField.defaultValue += element.radioText + ',';         
        });
      } else if (this.showDateField == true) {
          this.dateTypeFieldArray.forEach((element) => {         
          this.updateCustomField.defaultValue = '';
        });
      }
   // return;
    this.settingsService.AddFieldFolderMappingForExistingField(this.updateCustomField).subscribe((response) => {
        if (response != undefined) {
          this.spinner=false;
          this.updateFieldResponseHolder = response;
          this.inputTypeFieldArray = [];
          this.checkBoxFieldArray = [];
          this.dropdownFieldArray = [];
          if (this.updateFieldResponseHolder.status ==  this.statusConst.statusSuccess ) {
            this.updateCustomField.defaultValue='';
            this.toastr.success('Field import successfully.', '', {
              timeOut: 3000,
            });
            let closePanel = false;
            this.closecreateField(closePanel);
            this._dataSharingService.sendClickEventforfields();
          } else {
            this.folderIdCheck = true;
            this.spinner=false;
            this.loaderService.hide();
            this.toastr.error(this.updateFieldResponseHolder.message, '', {
            timeOut: 3000,
           });
          }
        }else {
          this.folderIdCheck = true;
          this.spinner=false;
          this.loaderService.hide();
        }
      });
  }

  valuechange(searchValue: string){
    this.updateCustomfieldForm.markAsDirty();
  }

  displayavailableonSelection(e) {
    this.updateCustomfieldForm.markAsDirty();
    if (this.checkArray.length != 0) {
      this.folderIdCheck = true;
    } else {
      this.folderIdCheck = false;
    }    
  }
  
  
  add(event: MatChipInputEvent): void {
    return;
    const input = event.input;
    const value = event.value.toLowerCase();
    this.allTags;
    var check=[];
    check= this.allTags.filter(x => x.toLowerCase().indexOf(value.trim()) === 0);
    if(check.length>0){    
     return;
    }   
    // Add our Feild
    if ((value || '').trim()) {
      var arrToUp = String.prototype.toLowerCase.apply(this.Feilds).split(",");
      const index = arrToUp.indexOf(value.trim());
      if (index >= 0) {
      }
      else {
        this.Feilds.push(event.value.trim());
      }
    }
    // Reset the input value
    if (input) {
      input.value = '';
    }
    if(this.Feilds.length>0){
      var CheckData=[];
      CheckData = this.FieldNameListFiltered.filter(x=> x.fieldName ==this.Feilds[0]);
      if(CheckData.length>0){
        var obj={
          fieldID:CheckData[0].fieldID
        }
        this.getGlobalFieldDetails(obj); 
      }
    }
   
  }

  remove(fruit: string): void {
    const index = this.Feilds.indexOf(fruit);

    if (index >= 0) {
      this.Feilds.splice(index, 1);
    }
    this.updateCustomfieldForm.reset();
    this.CreateFeild=true;
    this.ImportFeild=false;
    this.FieldNameListFiltered=[];
    this.corevaluesDropdown=[];
    this.contactvaluesDropdown=[];
    this.companyvaluesDropdown=[];

    this.selectedGlobalPermission="0";

    this.addCreatefieldForm.reset();
    this.addCreatefieldForm.controls['fieldCategoty'].setValue('2');
    this.showFieldVategoryTypeGlobal = true;
    this.showFieldVategoryTypecustom = false;
    this.clear();
    this.folderIdCheck = true;
    this.selectedRoleList=[];
  
    this.addCreatefieldForm.controls['fieldName'].setValue("");   
    this.showFieldVategoryTypeGlobal = true;
   

    this.folderIdCheckbox = [];  
    this.folderIdCheckbox.push(this.folderId);   
    var checkArray :FormArray;
    checkArray = this.addCreatefieldForm.get('checkArray') as FormArray; 
    checkArray.push(new FormControl(this.folderId));

    checkArray = this.updateCustomfieldForm.get('checkArray') as FormArray;  
    checkArray.clear();
    checkArray.push(new FormControl(this.folderId));   
    this.spinner=false;
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.Feilds =  this.Feilds.map(function (el) {
      return el.trim();
    });
    const index = this.Feilds.indexOf(event.option.viewValue);

    if (index >= 0) {
      this.feildInput.nativeElement.value = '';     
    }
    else {
      this.Feilds.push(event.option.viewValue);
      this.feildInput.nativeElement.value = '';
      // var CheckData=[];
      // CheckData = this.FieldNameListFiltered.filter(x=> x.fieldName ==this.Feilds[0]);
      // if(CheckData.length>0){
      //   this.Feilds=[];
      //   this.Feilds.push(event.option.viewValue+ " ("+ CheckData[0].fieldTypeName+ ")");
      // }   
    }
  }


  addValueField() {
    this.checkBoxFieldAttribute = null;
    let tempObject = Object.assign({}, this.checkBoxFieldAttribute);
    this.checkBoxFieldArray.push(tempObject);
  }


  deleteField(value,removeIndex) {
    if (value == 'c') {
     // let arrayLength = this.checkBoxFieldArray.length;
     // this.checkBoxFieldArray.splice(arrayLength - 1, 1);
      if (removeIndex !== -1) this.checkBoxFieldArray.splice(removeIndex, 1); 
    } else if (value == 'd') {
      //let arrayLength = this.dropdownFieldArray.length;
      //this.dropdownFieldArray.splice(arrayLength - 1, 1);
      if (removeIndex !== -1) this.dropdownFieldArray.splice(removeIndex, 1); 
    } else if (value == 'r') {
      //let arrayLength = this.radioFieldArray.length;
      //this.radioFieldArray.splice(arrayLength - 1, 1);
      if (removeIndex !== -1) this.radioFieldArray.splice(removeIndex, 1); 
    }   
  }
  
  onEnter(event){
    if(this.Feilds.length>0){
      var CheckData=[];
      CheckData = this.FieldNameListFiltered.filter(x=> x.fieldName ==this.Feilds[0]);
      if(CheckData.length>0){
        var obj={
          fieldID:CheckData[0].fieldID
        }
        this.getGlobalFieldDetails(obj); 
      }
    }
  }
  

   drop(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.dropdownFieldArray, event.previousIndex, event.currentIndex);
   }

   // addNewField(value) {
  //   this.folderDetail = this.commonService.getEditData();
  //   this.fieldType = this.commonService.getFieldType();
  //   if (this.folderDetail != undefined) {
  //     this.folderId = this.folderDetail.folderID;
  //   }
  //   this.addFieldsVM.defaultValue = '';
  //   this.addFieldsVM.userID = this.currentUser.UID;
  //   this.addFieldsVM.databaseID = parseInt(sessionStorage.getItem('databaseId'));

  //   this.addFieldsVM.folderName = this.folderDetail.folderName;
  //   this.addFieldsVM.fieldTypeID = this.typeSelected;
  //   if (this.fieldType.subfolderId > 0) {
  //     this.addFieldsVM.fieldFolderType = this.fieldType.fieldType;
  //     this.addFieldsVM.folderID = this.fieldType.subfolderId;
  //   } else {
  //     this.addFieldsVM.fieldFolderType = 1;
  //     this.addFieldsVM.folderID = this.folderId;
  //   }
  //   let count = this.fieldListFolderWise.length;
  //   this.addFieldsVM.position = count + 1;
  //   this.fieldTypeList.forEach((element) => {
  //     if (element.fieldTypeID == this.typeSelected) {
  //       this.addFieldsVM.fieldTypeName = element.fieldTypeName;
  //     }
  //   });
  //   if (this.showDropdownBoxField == true) {
  //     this.dropdownFieldArray.forEach((element) => {
  //       this.addFieldsVM.defaultValue += element.dropdownText + ',';
  //     });
  //   } else if (this.showCheckboxField == true) {
  //     this.checkBoxFieldArray.forEach((element) => {
  //       this.addFieldsVM.defaultValue += element.Select + ',';
  //     });
  //   } else if (this.showTextBoxField == true) {
  //     this.inputTypeFieldArray.forEach((element) => {
  //       this.addFieldsVM.defaultValue += element.fieldText;
  //       this.addFieldsVM.placeholder = element.placeholder;
  //     });
  //   } else if (this.showImageField == true) {
  //     this.imageTypeFieldArray.forEach((element) => {
  //       this.addFieldsVM.defaultValue += element.altText;
  //     });
  //   } else if (this.showUrlField == true) {
  //     this.urlTypeFieldArray.forEach((element) => {
  //       this.addFieldsVM.defaultValue += element.url;
  //     });
  //   } else if (this.showNumberField == true || this.showCurrencyField == true) {
  //     this.numberTypeFieldArray.forEach((element) => {
  //       this.addFieldsVM.defaultValue += element.number;
  //     });
  //   } else if (this.showRadioField == true) {
  //     this.radioFieldArray.forEach((element) => {
  //       this.addFieldsVM.defaultValue += element.radioText + ',';
  //     });
  //   }
  //   this.addFieldsVM.fieldName = this.fieldLabel;
  //   let lastIndex = this.addFieldsVM.defaultValue.length;
  //   this.addFieldsVM.defaultValue = this.addFieldsVM.defaultValue.substr(
  //     0,
  //     lastIndex - 1
  //   );
  //   this.addFieldsVM.organizationID=Number(sessionStorage.getItem('organizationID'));
  //   this.addFieldsVM.officeID=this.myOfficeID;
  //   this.addFieldsVM.OfficeIDList=this.OfficeIDList;
  //   this.settingsService.addField(this.addFieldsVM).subscribe((response) => {
  //     if (response != undefined) {
  //       this.addFieldResponseHolder = response;
  //       this.inputTypeFieldArray = [];
  //       this.checkBoxFieldArray = [];
  //       this.dropdownFieldArray = [];
  //       if (this.addFieldResponseHolder.status == this.statusConst.statusSuccess) {
  //         this.toastr.success('Field added successfully.', '', {
  //           timeOut: 3000,
  //         });
  //         this.closecreateField(false);
  //         this.getAllFields();
  //       } else {
  //         this.toastr.error(this.addFieldResponseHolder.message, '', {
  //           timeOut: 3000,
  //         });
  //         this.closeSlide.emit(false);
  //       }
  //     }
  //   });
  // }


}
